// eslint-disable-next-line
import React, { createElement, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sceneButtonsStyles } from './styles';
import { SceneButton } from '../SceneButton';
import {
    setScenesOpen,
    getScenesOpen,
    loadChecklist,
    displayProcedureContentVersion,
} from '../../features/globals/visibilitySlice';
import { getPreviousZone } from '../../features/zonePreview/zonePreviewSlice';
import clsx from 'clsx';

import { sceneButtonStyles } from '../SceneButton/styles';
import { getHomeZone, initAsset, selectAsset } from 'GeminiViewerComponent/features/asset/assetSlice';
import { loadZone } from 'shared/loadZoneSlice';
import { selectActiveTheme } from 'GeminiViewerComponent/features/globals/themeSlice';
import { accountsSlice } from 'app/store';
import { selectActiveAsset } from '../../features/asset/assetSlice';
import themes from 'GeminiViewerComponent/theme/defaultThemes';
import { Tooltip } from '@mui/material';
import { AssetTypes } from 'GeminiViewerComponent/helpers';

const { selectActiveUser } = accountsSlice;

const ToggleButton = ({ extraClasses, iconPath, theme, bgColor, id, tooltipTitle }) => {
    const dispatch = useDispatch();
    const scenesOpen = useSelector(getScenesOpen);

    const toggleScenes = () => dispatch(setScenesOpen(!scenesOpen));

    const classes = sceneButtonStyles(theme);

    return (
        <Tooltip title={tooltipTitle}>
            <div
                onClick={toggleScenes}
                id={id}
                className={clsx(classes.imageHoverContainer, classes.sceneButton, extraClasses)}
            >
                <img src={iconPath} className={clsx(classes.sceneImg, 'normal')} alt="normal-icon"></img>
            </div>
        </Tooltip>
    );
};

const SceneButtons = ({ mode = 'asset', style }) => {
    const dispatch = useDispatch();
    const classes = sceneButtonsStyles();
    const [preventImgCache, setPreventImgCache] = useState(null);
    const previousZone = useSelector(getPreviousZone);
    const homeZone = useSelector(getHomeZone);
    const activeUser = useSelector(selectActiveUser);
    const asset = useSelector(selectActiveAsset);
    const theme = useSelector(selectActiveTheme);
    const getAsset = useSelector(selectAsset);
    const clientID = asset?.client_id || activeUser?.client_id;
    const s3Prefix = activeUser?.s3_prefix || asset.s3_prefix;
    const themeIconPath = theme?.id && theme?.id !== themes?.default?.id ? '/' + theme.id : '';
    const toggleIconPath = `${s3Prefix}client_${clientID}/ThemeData${themeIconPath}/nav_hamburger_icon.svg?${preventImgCache}`;
    const homeIconPath = `${s3Prefix}client_${clientID}/ThemeData${themeIconPath}/nav_home_icon.svg?${preventImgCache}`;
    const backIconPath = `${s3Prefix}client_${clientID}/ThemeData${themeIconPath}/nav_back_icon.svg?${preventImgCache}`;

    useEffect(() => {
        if ((mode === 'asset' || mode === 'preview') && preventImgCache === null) {
            setPreventImgCache(new Date().getTime());
        }
    }, [mode]);

    async function goBack() {
        if (previousZone != null) {
            if (previousZone.assetId !== asset.asset_id) {
                const asset = getAsset(previousZone.assetId, previousZone.zoneId);

                if (asset.asset_type_id !== AssetTypes.Procedure) {
                    // if not procedure
                    dispatch(displayProcedureContentVersion(null));
                    dispatch(loadChecklist(false));
                }
                await dispatch(initAsset({ s3_prefix: activeUser.s3_prefix, ...asset }));
            }
            dispatch(loadZone({ zoneId: previousZone.zoneId, backup: true }));
        }
    }

    function goHome() {
        if (homeZone != null) {
            dispatch(loadZone({ zoneId: homeZone.zone_id }));
        }
    }

    return (
        <div className={classes.sceneButtons} style={style}>
            <ToggleButton
                id="viewer_title_zone-nav-btn"
                iconPath={toggleIconPath}
                theme={theme}
                tooltipTitle="Zone Navigation"
            />
            <SceneButton
                id="viewer_title_back-btn"
                iconPath={backIconPath}
                onClick={goBack}
                tooltipTitle="Previous Zone"
            />
            <SceneButton id="viewer_title_home-btn" iconPath={homeIconPath} onClick={goHome} tooltipTitle="Home Zone" />
        </div>
    );
};

export { SceneButtons };
